var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70462 8.10625L4.65387 3.14801C4.48671 2.98391 4.40312 2.78464 4.40312 2.55021C4.40312 2.31577 4.48671 2.11651 4.65387 1.9524C4.82104 1.7883 5.02402 1.70625 5.26283 1.70625C5.50163 1.70625 5.70462 1.7883 5.87178 1.9524L11.227 7.20955C11.3583 7.33848 11.4539 7.47914 11.5136 7.63152C11.5733 7.78391 11.6031 7.94215 11.6031 8.10625C11.6031 8.27035 11.5733 8.42859 11.5136 8.58098C11.4539 8.73336 11.3583 8.87402 11.227 9.00295L5.87178 14.2601C5.70462 14.4242 5.50163 14.5063 5.26283 14.5063C5.02402 14.5063 4.82104 14.4242 4.65387 14.2601C4.48671 14.096 4.40312 13.8967 4.40312 13.6623C4.40312 13.4279 4.48671 13.2286 4.65387 13.0645L9.70462 8.10625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationChevronRight);
export default __webpack_public_path__ + "static/media/Pagination_chevron_right.59f1b791712fab9692050008c8fde77b.svg";
export { ForwardRef as ReactComponent };